// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'

const FormatElevationHeader = ({ unitType }) => (
  <div className={'display-flex flex-direction-row flex-wrap-nowrap'}>
    <span>{`Ground Elev (${unitType === 'SI' ? 'm' : 'ft'})`}</span>
    <span
      className={'fa fa-question-circle margin-left-half line-height-inherit'}
      id={`asr-lookup-elevation-header-question-circle`}
      title={'Height above mean sea level'} />
  </div>
)

FormatElevationHeader.propTypes = {
  unitType: string.isRequired,
}

export default FormatElevationHeader
